module.exports = __webpack_public_path__ + "assets/ziyuan_13.a56c4de7.svg";